import { TextField } from '@mui/material';
import styled from 'styled-components';

export const SearchField = styled(TextField)`
  background: #fff;
  margin-bottom: 16px;
  font-size: 12px;
`;
